import styled, { css } from 'styled-components';

const visible = css`
  visibility: visible;
  opacity: 1;
  transition: opacity 1s ease-in-out, visibility 1s ease-in-out;
  display: flex;
  min-height: 700px;
`;

const hidden = css`
  visibility: hidden;
  opacity: 0;
  transition: opacity 1s ease-in-out, visibility 1s ease-in-out, display 0s 1s;
  display: none;
`;

const LocationWrapper = styled.div`
  min-width: 0;
  ${props => (props.isVisible ? visible : hidden)}
`;

export default LocationWrapper;
